import styled from 'styled-components'
import theme from '../../styles/theme'
export const ButtonWrapper = styled.div`
  padding: ${({ isInPageBody }) => (isInPageBody ? '1.5rem 0' : '1.5rem 16px')};
  background: ${({ haveTitle }) => (haveTitle ? '#ebebeb' : 'none')};
  margin-top: ${({ haveTitle }) => (haveTitle ? '1rem' : '0')};
`

export const ButtonTitle = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1rem 1rem 1rem;
  color: ${theme.color.black};
`
